
import Utils from './utils/Utils';
import PhoneMenu from './utils/PhoneMenu';

function MenuController(clickCallback) {

	this.clickCallback = clickCallback;
	this.phoneMenu = null;
	this.mapOpen = false;
	this.navOpen = false;
	this.navMode = 'flyout'; // can be'flyout' for drop down menu style or 'slideout' for phone type nav

	$(window).resize( $.proxy( this.handleResize, this ) );

	console.log('HERE');

}

MenuController.prototype = {

	setupNav : function(type) {
		this.navMode= type;

		// FOR TABS AND DESKTOP MENU
	/*	if( type == 'flyout') {

			//init the menu functionality
			this.phoneMenu = null;

			$('#navButton').on('click', $.proxy(function(e) {

				if( this.navOpen ) {
					this.closeNav();
				} else {
					$('#navMenu').css('display','block');
					$('#navMenuSheet').animate( {'top':'0px'}, { duration: 200 } );

					this.navOpen = true;

					$('#navMenu').on('mouseleave',$.proxy(function(e){
						this.closeNav();
					},this));

					_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Open' ]);
				}

			},this));

		//FOR MOBILE MENU
		} else {*/

			if( !this.phoneMenu ) {
				var menu_width = 300;
				if( $(window).width() < 640 )
					menu_width = $(window).width() - 75;

				this.phoneMenu = new PhoneMenu( {'width':menu_width} );
				$(this.phoneMenu).on( 'openComplete', $.proxy( this.handleCompressedNavOpened, this ) );
				$(this.phoneMenu).on( 'closeComplete', $.proxy( this.handleCompressedNavClosed, this ) );
			}

			$('#navButton').on('click', $.proxy(function(e) {

				this.phoneMenu.toggle();

				if(this.phoneMenu.opened) {
					//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Open' ]);
          ga('send', 'event', 'Menu', this.navMode, 'Open' );
				} else {
					//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Close' ]);
          ga('send', 'event', 'Menu', this.navMode, 'Close' );
        }


			},this) );

		//}

		if( this.clickCallback ) {
			//override clicks on nav
			$('#navMenu a').each( $.proxy( function(i) {
				$($('#navMenu').children()[i]).on('click',{ index: i }, $.proxy(function(e){this.clickCallback(e);}, this ) );
			},this));
		}

		this.handleResize();

	},

	handleCompressedNavOpened: function() {
		$('html,body').css('overflow','hidden');
		$('html,body').on('touchmove',function(e){e.preventDefault();});
	},

	handleCompressedNavClosed: function() {
		$('html,body').css('overflow','visible');
		$('html,body').off('touchmove');

		//$('.container').css('transform','');

	},

	handleResize: function(e) {

		if( $(window).width() < 640 && this.phoneMenu !== null  ) {
			this.phoneMenu.setMenuWidth( $(window).width() - 75 );
			$('.navMenuContainer ul').width($(window).width() - 76);
		} else {
			this.phoneMenu.setMenuWidth( 300 );
			$('.navMenuContainer ul').width('');
		}

	},

	closeNav:function() {

		if( this.navMode == 'flyout' ) {
			$('#navMenu').off('mouseleave');
			//$('#navMenu').fadeOut(200);
			$('#navMenuSheet').animate( {'top':'-450px'}, { duration: 200 } );

			this.navOpen = false;
		} else {
			console.log('CLOSE MENU');
			this.phoneMenu.close();
		}

		//_gaq.push(['_trackEvent', 'Menu', this.navMode, 'Close' ]);
    ga('send', 'event', 'Menu', this.navMode, 'Close' );


	},

	unsetNav : function() {
		$('#navButton').off('click');
		$('#navButton').off('mouseenter');
		$('.navMenuContainer').css('display','');
		this.navOpen = false;
	}


};

module.exports = MenuController;



// WEBPACK FOOTER //
// ./js/src/MenuController.js